import { Component, OnInit, QueryList, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { CfetBaseComponent, CfetService, AdobeAnalyticsService, CfetNavigationDirective } from './../../cfet-core';
import 'element-closest-polyfill';

@Component({
    selector: 'app-cfet-nav-header',
    templateUrl: './cfet-nav-header.component.html',
    styleUrls: ['./cfet-nav-header.component.scss'],
    standalone: false
})
export class CfetNavHeaderComponent extends CfetBaseComponent implements OnInit {
  isLandingPage: boolean;
  trapFocusForCato: boolean;

  @ViewChildren(CfetNavigationDirective) inputs: QueryList<CfetNavigationDirective>;

  constructor(private adobeAnalyticsService: AdobeAnalyticsService,
    private cfetService: CfetService,
    private changedetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit () {
    this.cfetService.isLandingPage.subscribe((flag) => {
      this.isLandingPage = flag;
      this.changedetector.detectChanges();
    });
    this.cfetService.trapFocus.subscribe((flag) => {
      this.trapFocusForCato = flag;
      this.changedetector.detectChanges();
    });
  }

  adobeLinkClick (linkName, destUrl, path, position?: any) {
    const eventData = {
      eventAction: 'linkClick',
      eventCode: 'Link_Click',
      objData: {
        linkName: linkName,
        linkPosition: position ? position : 'GlobalNavTopBar',
        linkDestinationUrl: `${window.location.host}${destUrl}`,
        linkPath: path ? path : '',
        supmethod: 'OT'
      }
    };
    this.adobeAnalyticsService.pushToDatalayerPushEvent(eventData.eventAction, eventData.eventCode, eventData.objData);
  }

}
